import { ApolloCache } from "@apollo/client"

import { QueryTypename } from "shared/api/types"

import {
  TeamDocument,
  TeamQuery,
  TeamQueryVariables,
  TeamsDocument,
  TeamsQuery,
  TeamsQueryVariables
} from "../graphql/queries.generated"
import { Team } from "../types/Team"
import { readTeams } from "./readTeams"

export function createTeamInCache({
  cache,
  team
}: {
  cache: ApolloCache<object>
  team?: Team | null
}) {
  if (team) {
    const teams = readTeams(cache)

    if (teams) {
      cache.writeQuery<TeamsQuery, TeamsQueryVariables>({
        data: { __typename: QueryTypename, teams: [...teams, team] },
        query: TeamsDocument
      })
      cache.writeQuery<TeamQuery, TeamQueryVariables>({
        data: { __typename: QueryTypename, team },
        query: TeamDocument,
        variables: { id: team.id }
      })
    }
  }
}
